import { UniversitySliderCopy } from '@uc/web/shared/features/feature-university-slider';

export const preClearingCopy = (
	currentYear: number,
	uniName: string,
): UniversitySliderCopy => {
	return {
		studyType: 'Clearing',
		heading: `Clearing ${currentYear} at ${uniName}`,
		text: `Clearing ${currentYear} starts in July. Check back then to see if ${uniName} has any available courses.`,
	};
};

export const CLEARING_COPY: UniversitySliderCopy = {
	studyType: 'Clearing',
	heading: 'Clearing vacancies are available 🎉 ',
	text: 'Get in touch with the university to reserve your place now.',
};

export const POST_CLEARING_COPY: UniversitySliderCopy = {
	studyType: 'Clearing',
	heading: 'Clearing at Uni Compare is closed',
	text: `Clearing has now closed at Uni Compare. Check back next year for Clearing ${
		new Date().getFullYear() + 1
	}.`,
};

export const getNonClientClearingCopy = (currentYear: number): UniversitySliderCopy => {
	return {
		studyType: 'Clearing',
		heading: `This University Is Not Active for Clearing ${currentYear} at Uni Compare`,
		text: `Download our Clearing app and create an account to find your place in Clearing ${currentYear}.`,
	};
};
